import { useTranslation } from '@/i18n';
import { useMemberGroupCards } from '@/hooks-v2/aggregator';

interface MemberGroupCardsSectionProps {
  merchantId: number;
  userId: string;
}

export default function MemberGroupCardsSection({ merchantId, userId }: MemberGroupCardsSectionProps): React.JSX.Element | null {
  const { t } = useTranslation();
  const groups = useMemberGroupCards(merchantId, userId);

  const errorCode = groups.error !== null && 'code' in groups.error && typeof groups.error.code === 'string'
    ? groups.error.code
    : null;
  if (errorCode === 'FORBIDDEN') return null;
  return (
    <section className="mb-8 rounded-lg border border-gray-200 p-4" aria-labelledby="group-member-cards-heading">
      <h3 id="group-member-cards-heading" className="mb-3 text-lg font-semibold">{t('merchant.analytics.groupCards.title')}</h3>
      {groups.isLoading ? <p role="status">{t('common.loading')}</p> : groups.error !== null ? (
        <div><p role="alert">{t('merchant.analytics.groupCards.loadFailed')}</p><button type="button" onClick={groups.refetch}>{t('merchant.analytics.groupCards.retry')}</button></div>
      ) : groups.groups.length === 0 ? <p className="text-sm text-gray-600">{t('merchant.analytics.groupCards.none')}</p> : (
        <ul className="space-y-2">
          {groups.groups.map(group => <li key={group.card_id} className="rounded bg-gray-50 p-3"><span className="block font-medium">{group.group_name}</span><span className="font-mono text-sm text-gray-700">{group.member_id}</span></li>)}
        </ul>
      )}
    </section>
  );
}
